import { render, staticRenderFns } from "./Finished-in-B.vue?vue&type=template&id=5fd2c123&"
import script from "./Finished-in-B.vue?vue&type=script&lang=js&"
export * from "./Finished-in-B.vue?vue&type=script&lang=js&"
import style0 from "./Finished-in-B.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports